import ThemeProvider from 'ripple/ThemeProvider';
import * as OfflinePluginRuntime from '@lcdp/offline-plugin/runtime';
import React from 'react';
import ReactDOM from 'react-dom';

import { AuthProvider } from 'AuthContext';
import { ResponsiveProvider } from 'ResponsiveContext';
import ErrorBoundary from 'components/ErrorBoundary';
import { createProductionBrowserRouter } from 'lib/routeUtils';
import ErrorPage from 'pages/Error';
import GraphQLProvider from 'utils/graphql/GraphQLProvider';
import AudienceTrackerProvider from './lib/trackers/Audience';

const rootEl = document.getElementById('app');

const render = async () => {
  const ProductionBrowserRouter = await createProductionBrowserRouter();
  ReactDOM.hydrate(
    <ResponsiveProvider>
      <ThemeProvider>
        <ErrorBoundary>
          <AudienceTrackerProvider>
            <GraphQLProvider>
              <AuthProvider>
                <ProductionBrowserRouter />
              </AuthProvider>
            </GraphQLProvider>
          </AudienceTrackerProvider>
        </ErrorBoundary>
      </ThemeProvider>
    </ResponsiveProvider>,
    rootEl,
  );
};

render()
  .then(() => {
    // eslint-disable-next-line no-console
    console.log('Ripple Street ready!');
  })
  .catch(e => {
    ReactDOM.render(<ErrorPage />, rootEl);
    // eslint-disable-next-line no-console
    console.error(e);
  });

// Install the offline plugin, which instantiates our service worker and app
// cache to support precaching of assets and offline support.
OfflinePluginRuntime.install({
  // When an update is ready we will tell the new SW to take control immediately.
  onUpdateReady: () => OfflinePluginRuntime.applyUpdate(),
  // After the new SW update has been applied we will reload the users page
  // to ensure they are using the latest assets.
  // This only gets run if there were updates available for our cached assets.
  onUpdated: () => window.location.reload(),
});
